import {
  ApiInterface,
  EmptyObject,
  PaginatedQueryParams,
  PaginatedResponse,
} from '@stetamalo/cloud-platform/catalog/api';
import { ApiConfig } from 'services/support/utils/types/api-config';
import { Servicios } from '../../../entities/servicios';

export type Interface = ApiInterface<{
  response: PaginatedResponse<Servicios>;
  pathParams: EmptyObject;
  body: EmptyObject;
  claims: { tenantId: string };
  queryParams: PaginatedQueryParams & { query?: string };
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-list-servicios',
  method: 'GET',
  basePath: 'servicios',
  path: '/',
  tablePermission: 'read',
  scope: 'RECEPTIONIST',
};
